/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtabpt4Inputs */

const en_letterpreviewtabpt4 = /** @type {(inputs: Letterpreviewtabpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portuguese (sent to contractor)`)
};

const pt_letterpreviewtabpt4 = /** @type {(inputs: Letterpreviewtabpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português (enviada ao empreiteiro)`)
};

/**
* | output |
* | --- |
* | "Portuguese (sent to contractor)" |
*
* @param {Letterpreviewtabpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtabpt4 = /** @type {((inputs?: Letterpreviewtabpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtabpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtabpt4(inputs)
	return pt_letterpreviewtabpt4(inputs)
});
export { letterpreviewtabpt4 as "letterPreviewTabPT" }